import React from "react";
import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";

const TermsCondition = () => {
  const data: any = useSelector((state: any) =>
    state.profile.termCondition ? state.profile.termCondition : {}
  );
  const commonLoading: any = useSelector((state: any) =>
    state.common.loader ? state.common.loader : false
  );
  return (
    <div className="tc_box">
      <div className="heading_box">Terms & Conditions</div>
      {commonLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader type="ThreeDots" color="#fff" height={100} width={100} />
            </div>
          ) : (
      <div className="tc_des_box">
        <h6>Terms & Conditions</h6>
        <p dangerouslySetInnerHTML={{__html: data?.["terms&conditions"]}}>
        </p>
      </div>
          )}
      {/* <div className="col-12 text-center">
        <button type="submit" className="book--hexagon active sm_form">
          <span className="text-capitalize">
            View More
            <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
          </span>
        </button>
      </div> */}
    </div>
  );
};

export default TermsCondition;
